"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_ACTIONS_COL_DEF = void 0;
exports.getActionsColWidthByLimit = getActionsColWidthByLimit;
var _excluded = ["actionsComponent", "limit", "isActionVisible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var GRID_ACTIONS_FIELD = 'actions';
var DEFAULT_LIMIT = 1;
function getActionsColWidthByLimit() {
  var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_LIMIT;
  switch (limit) {
    case 1:
      return 68;
    case 2:
      return 110;
    case 3:
      return 158;
    default:
      return 158;
  }
}
var GRID_ACTIONS_COL_DEF = exports.GRID_ACTIONS_COL_DEF = {
  limit: DEFAULT_LIMIT,
  fixedRight: true,
  headerName: 'Actions',
  sortable: false,
  disableColumnMenu: true,
  width: function width(colDef) {
    return getActionsColWidthByLimit(colDef.limit);
  },
  resizable: false,
  field: GRID_ACTIONS_FIELD,
  renderCell: function renderCell(params) {
    var colDef = params.colDef;
    var actionsComponent = colDef.actionsComponent,
      limit = colDef.limit,
      isActionVisible = colDef.isActionVisible,
      props = _objectWithoutProperties(colDef, _excluded);
    var visible = isActionVisible ? isActionVisible(params) : true;
    if (!visible) {
      return null;
    }
    var callbacks = Object.keys(props).reduce(function (acc, key) {
      if (key.startsWith('on')) {
        acc[key] = props[key];
      }
      return acc;
    }, {});
    return React.createElement(actionsComponent, _objectSpread({
      data: params.row,
      actions: params.value,
      limit: limit,
      colDef: colDef
    }, callbacks));
  }
};